import { PageShell } from "@/components/PageShell";
import { SocialFeed } from "@/components/SocialFeed";
import { StoryInvite } from "@/components/HomeSections";
import { useSeo } from "@/hooks/useSeo";

export default function SocialPage() {
  useSeo({
    title: "Instagram DonnaImpresa | Gli ultimi post della rete",
    description:
      "Gli ultimi post del profilo Instagram di DonnaImpresa: incontri, storie di socie e nuove partnership della rete delle imprenditrici. Scrivici a impresahub@gmail.com.",
    path: "/social",
  });

  return (
    <PageShell testId="social-page">
      <SocialFeed />
      <StoryInvite />
    </PageShell>
  );
}
